import { FuelTypography } from '@frete.com/fuel-react';
import styled from 'styled-components';

export const VerifiedIcon = styled.span`
  color: ${({ theme }) => theme.color.support.blue.strong};
`;

export const Name = styled(FuelTypography)`
  .typography {
    max-width: 171px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
